import { heicTo } from 'heic-to';

/**
 * Check if a file is HEIC/HEIF format
 */
export const isHeicFile = (file: File): boolean =>
  file.type === 'image/heic' ||
  file.type === 'image/heif' ||
  file.name.toLowerCase().endsWith('.heic') ||
  file.name.toLowerCase().endsWith('.heif');

/**
 * Convert a HEIC/HEIF file to JPEG. Returns { file, url } where url is a blob URL for preview.
 * For non-HEIC files, returns the original file with a blob URL.
 */
export const convertHeicToJpeg = async (
  file: File,
  quality = 0.85
): Promise<{ file: File; url: string }> => {
  if (!isHeicFile(file)) {
    return { file, url: URL.createObjectURL(file) };
  }
  const jpegBlob = await heicTo({ blob: file, type: 'image/jpeg', quality });
  const newName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
  const newFile = new File([jpegBlob], newName, { type: 'image/jpeg' });
  return { file: newFile, url: URL.createObjectURL(jpegBlob) };
};
